import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// A pit's spot on the map (Ryan, Oct 23 2026: "I don't think the map works on Find on map").
// Click the map to drop the pin, drag it onto the gate; Satellite shows the pits themselves.
// The point is what drive times are worked out from.

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const RENO = [39.53, -119.81];
function Follow({ point }) {
  const map = useMap();
  useEffect(() => { if (point) map.setView(point, Math.max(map.getZoom(), 14)); }, [point && point[0], point && point[1]]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
function ClickToPlace({ onPlace }) {
  useMapEvents({ click(e) { onPlace(e.latlng.lat, e.latlng.lng); } });
  return null;
}

export default function PitMap({ lat, lng, onChange, height = 300 }) {
  const [sat, setSat] = useState(true);
  const point = lat != null && lng != null && Number.isFinite(Number(lat)) ? [Number(lat), Number(lng)] : null;
  return (
    <div style={{ position: 'relative', borderRadius: 10, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
      <MapContainer center={point || RENO} zoom={point ? 14 : 9} style={{ height, width: '100%' }}>
        {sat
          ? <TileLayer attribution="Imagery &copy; Esri" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
          : <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />}
        <Follow point={point} />
        <ClickToPlace onPlace={(a, b) => onChange(a, b)} />
        {point && <Marker position={point} draggable eventHandlers={{ dragend: e => { const ll = e.target.getLatLng(); onChange(ll.lat, ll.lng); } }} />}
      </MapContainer>
      <div style={{ position: 'absolute', top: 8, right: 8, zIndex: 500, display: 'flex', borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.3)' }}>
        {[['Satellite', true], ['Map', false]].map(([l, v]) => (
          <button key={l} type="button" onClick={() => setSat(v)} style={{ border: 'none', padding: '5px 10px', fontSize: 12, fontWeight: 800, cursor: 'pointer', background: sat === v ? '#1e3a5f' : '#fff', color: sat === v ? '#fff' : '#1e3a5f' }}>{l}</button>
        ))}
      </div>
      <div style={{ position: 'absolute', left: 8, bottom: 8, zIndex: 500, background: 'rgba(255,255,255,0.92)', borderRadius: 6, padding: '3px 8px', fontSize: 11.5, fontWeight: 700, color: '#374151' }}>
        {point ? 'Drag the pin onto the pit gate — or click the map' : 'Click the map where the pit is'}
      </div>
    </div>
  );
}
